import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=91d9bc70&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=91d9bc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d9bc70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderInstagramStories: require('/app/components/HeaderInstagramStories.vue').default,HeaderSearchAlgolia: require('/app/components/HeaderSearchAlgolia.vue').default,HeaderVehicleSelector: require('/app/components/HeaderVehicleSelector.vue').default,LanguageSelection: require('/app/components/LanguageSelection.vue').default,HeaderFavorites: require('/app/components/HeaderFavorites.vue').default,HeaderCart: require('/app/components/HeaderCart.vue').default,Header: require('/app/components/Header.vue').default})
